import { render, staticRenderFns } from "./DataManage.vue?vue&type=template&id=2b27e72c&scoped=true&"
import script from "./DataManage.vue?vue&type=script&lang=js&"
export * from "./DataManage.vue?vue&type=script&lang=js&"
import style0 from "./DataManage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DataManage.vue?vue&type=style&index=1&id=2b27e72c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b27e72c",
  null
  
)

export default component.exports